[
  {
    "country_id": 1,
    "id": 1,
    "industrial_areas": [
      {
        "coordinates": [
          {
            "latitude": 24.868778,
            "longitude": 55.024627
          },
          {
            "latitude": 24.797118,
            "longitude": 55.084141
          },
          {
            "latitude": 24.826767,
            "longitude": 55.129911
          },
          {
            "latitude": 24.899381,
            "longitude": 55.072559
          },
          {
            "latitude": 24.870383,
            "longitude": 55.027163
          }
        ],
        "freezone": false,
        "id": 1,
        "name": "Dubai Industrial City",
        "region_id": 1,
        "website": "https://dubaiindustrialcity.ae/"
      },
      {
        "coordinates": [
          {
            "latitude": 24.975002,
            "longitude": 55.142292
          },
          {
            "latitude": 24.968801,
            "longitude": 55.162164
          },
          {
            "latitude": 24.959569,
            "longitude": 55.204702
          },
          {
            "latitude": 24.955731,
            "longitude": 55.215463
          },
          {
            "latitude": 24.9541,
            "longitude": 55.234545
          },
          {
            "latitude": 24.977119,
            "longitude": 55.240364
          },
          {
            "latitude": 24.979802,
            "longitude": 55.236811
          },
          {
            "latitude": 24.982256,
            "longitude": 55.232013
          },
          {
            "latitude": 24.990211,
            "longitude": 55.214345
          },
          {
            "latitude": 24.992285,
            "longitude": 55.207378
          },
          {
            "latitude": 24.994519,
            "longitude": 55.192314
          },
          {
            "latitude": 24.99744,
            "longitude": 55.184203
          },
          {
            "latitude": 25.002201,
            "longitude": 55.176282
          },
          {
            "latitude": 25.015072,
            "longitude": 55.162317
          },
          {
            "latitude": 25.017252,
            "longitude": 55.15872
          },
          {
            "latitude": 25.005412,
            "longitude": 55.150916
          },
          {
            "latitude": 24.999517,
            "longitude": 55.148076
          },
          {
            "latitude": 24.993539,
            "longitude": 55.146207
          },
          {
            "latitude": 24.979272,
            "longitude": 55.143232
          }
        ],
        "freezone": false,
        "id": 2,
        "name": "Dubai Investment Park",
        "region_id": 1,
        "website": "https://www.dipark.com/WebPages/Page?pageName=Industrial"
      },
      {
        "coordinates": [
          {
            "latitude": 24.854815,
            "longitude": 54.99452
          },
          {
            "latitude": 24.890579,
            "longitude": 55.054042
          },
          {
            "latitude": 24.906111,
            "longitude": 55.056282
          },
          {
            "latitude": 24.91868,
            "longitude": 55.100809
          },
          {
            "latitude": 24.963629,
            "longitude": 55.0738
          },
          {
            "latitude": 24.968497,
            "longitude": 55.036156
          },
          {
            "latitude": 24.944867,
            "longitude": 54.99683
          },
          {
            "latitude": 24.89325,
            "longitude": 54.971426
          }
        ],
        "freezone": false,
        "id": 3,
        "name": "National Industries Park",
        "region_id": 1,
        "website": "https://www.nip.ae/"
      },
      {
        "coordinates": [
          {
            "latitude": 24.841858,
            "longitude": 55.08833
          },
          {
            "latitude": 24.883474,
            "longitude": 55.125801
          },
          {
            "latitude": 24.894986,
            "longitude": 55.124972
          },
          {
            "latitude": 24.916172,
            "longitude": 55.155243
          },
          {
            "latitude": 24.940181,
            "longitude": 55.128579
          },
          {
            "latitude": 24.933131,
            "longitude": 55.100541
          },
          {
            "latitude": 24.905635,
            "longitude": 55.075783
          },
          {
            "latitude": 24.862387,
            "longitude": 55.06553
          }
        ],
        "freezone": false,
        "id": 4,
        "name": "Dubai Logistics City",
        "region_id": 1,
        "website": null
      },
      {
        "coordinates": [
          {
            "latitude": 24.988109,
            "longitude": 55.093114
          },
          {
            "latitude": 24.988106,
            "longitude": 55.093122
          },
          {
            "latitude": 24.98784,
            "longitude": 55.093866
          },
          {
            "latitude": 24.987371,
            "longitude": 55.094997
          },
          {
            "latitude": 24.987017,
            "longitude": 55.095922
          },
          {
            "latitude": 24.986925,
            "longitude": 55.096195
          },
          {
            "latitude": 24.986837,
            "longitude": 55.096459
          },
          {
            "latitude": 24.986525,
            "longitude": 55.097841
          },
          {
            "latitude": 24.986317,
            "longitude": 55.09858
          },
          {
            "latitude": 24.986063,
            "longitude": 55.099448
          },
          {
            "latitude": 24.985603,
            "longitude": 55.10098
          },
          {
            "latitude": 24.984988,
            "longitude": 55.103028
          },
          {
            "latitude": 24.982499,
            "longitude": 55.111192
          },
          {
            "latitude": 24.981948,
            "longitude": 55.113018
          },
          {
            "latitude": 24.981531,
            "longitude": 55.114496
          },
          {
            "latitude": 24.981159,
            "longitude": 55.115845
          },
          {
            "latitude": 24.980124,
            "longitude": 55.119598
          },
          {
            "latitude": 24.979803,
            "longitude": 55.12081
          },
          {
            "latitude": 24.979571,
            "longitude": 55.121761
          },
          {
            "latitude": 24.979251,
            "longitude": 55.123209
          },
          {
            "latitude": 24.9792,
            "longitude": 55.123453
          },
          {
            "latitude": 24.978768,
            "longitude": 55.125527
          },
          {
            "latitude": 24.977806,
            "longitude": 55.130133
          },
          {
            "latitude": 24.97678,
            "longitude": 55.134992
          },
          {
            "latitude": 24.975872,
            "longitude": 55.139192
          },
          {
            "latitude": 24.975689,
            "longitude": 55.139875
          },
          {
            "latitude": 24.975002,
            "longitude": 55.142292
          },
          {
            "latitude": 24.979272,
            "longitude": 55.143232
          },
          {
            "latitude": 24.982611,
            "longitude": 55.14392
          },
          {
            "latitude": 24.990357,
            "longitude": 55.145489
          },
          {
            "latitude": 24.993539,
            "longitude": 55.146207
          },
          {
            "latitude": 24.994797,
            "longitude": 55.146559
          },
          {
            "latitude": 24.996157,
            "longitude": 55.146955
          },
          {
            "latitude": 24.997509,
            "longitude": 55.147382
          },
          {
            "latitude": 24.999517,
            "longitude": 55.148076
          },
          {
            "latitude": 25.002027,
            "longitude": 55.149154
          },
          {
            "latitude": 25.003715,
            "longitude": 55.150002
          },
          {
            "latitude": 25.005412,
            "longitude": 55.150916
          },
          {
            "latitude": 25.006891,
            "longitude": 55.151824
          },
          {
            "latitude": 25.008119,
            "longitude": 55.152577
          },
          {
            "latitude": 25.008507,
            "longitude": 55.152835
          },
          {
            "latitude": 25.010867,
            "longitude": 55.15445
          },
          {
            "latitude": 25.012145,
            "longitude": 55.155271
          },
          {
            "latitude": 25.017252,
            "longitude": 55.15872
          },
          {
            "latitude": 25.017506,
            "longitude": 55.157615
          },
          {
            "latitude": 25.017706,
            "longitude": 55.156914
          },
          {
            "latitude": 25.01814,
            "longitude": 55.154759
          },
          {
            "latitude": 25.018289,
            "longitude": 55.153296
          },
          {
            "latitude": 25.018313,
            "longitude": 55.151456
          },
          {
            "latitude": 25.017154,
            "longitude": 55.141283
          },
          {
            "latitude": 25.016953,
            "longitude": 55.138721
          },
          {
            "latitude": 25.016863,
            "longitude": 55.137051
          },
          {
            "latitude": 25.016821,
            "longitude": 55.135454
          },
          {
            "latitude": 25.01666,
            "longitude": 55.12938
          },
          {
            "latitude": 25.017771,
            "longitude": 55.106524
          },
          {
            "latitude": 25.018066,
            "longitude": 55.100457
          },
          {
            "latitude": 25.018163,
            "longitude": 55.097777
          },
          {
            "latitude": 25.000032,
            "longitude": 55.094949
          },
          {
            "latitude": 24.988826,
            "longitude": 55.093207
          }
        ],
        "freezone": false,
        "id": 5,
        "name": "Jebel Ali Industrial Area",
        "region_id": 1,
        "website": null
      },
      {
        "coordinates": [
          {
            "latitude": 24.94702,
            "longitude": 55.062365
          },
          {
            "latitude": 24.944542,
            "longitude": 55.064956
          },
          {
            "latitude": 24.943123,
            "longitude": 55.066448
          },
          {
            "latitude": 24.936989,
            "longitude": 55.076211
          },
          {
            "latitude": 24.928408,
            "longitude": 55.089875
          },
          {
            "latitude": 24.927167,
            "longitude": 55.091852
          },
          {
            "latitude": 24.919593,
            "longitude": 55.103912
          },
          {
            "latitude": 24.923727,
            "longitude": 55.109194
          },
          {
            "latitude": 24.926499,
            "longitude": 55.112492
          },
          {
            "latitude": 24.92914,
            "longitude": 55.115322
          },
          {
            "latitude": 24.932424,
            "longitude": 55.118571
          },
          {
            "latitude": 24.934725,
            "longitude": 55.120674
          },
          {
            "latitude": 24.936644,
            "longitude": 55.122357
          },
          {
            "latitude": 24.939025,
            "longitude": 55.124312
          },
          {
            "latitude": 24.9429,
            "longitude": 55.127207
          },
          {
            "latitude": 24.945895,
            "longitude": 55.129303
          },
          {
            "latitude": 24.950418,
            "longitude": 55.132157
          },
          {
            "latitude": 24.953195,
            "longitude": 55.133721
          },
          {
            "latitude": 24.959445,
            "longitude": 55.136863
          },
          {
            "latitude": 24.964707,
            "longitude": 55.139055
          },
          {
            "latitude": 24.969457,
            "longitude": 55.140686
          },
          {
            "latitude": 24.971923,
            "longitude": 55.141419
          },
          {
            "latitude": 24.973949,
            "longitude": 55.141994
          },
          {
            "latitude": 24.974983,
            "longitude": 55.142268
          },
          {
            "latitude": 24.975788,
            "longitude": 55.139428
          },
          {
            "latitude": 24.97682,
            "longitude": 55.134401
          },
          {
            "latitude": 24.978223,
            "longitude": 55.127551
          },
          {
            "latitude": 24.979255,
            "longitude": 55.122483
          },
          {
            "latitude": 24.979518,
            "longitude": 55.121381
          },
          {
            "latitude": 24.980118,
            "longitude": 55.119043
          },
          {
            "latitude": 24.9821,
            "longitude": 55.112053
          },
          {
            "latitude": 24.982527,
            "longitude": 55.110639
          },
          {
            "latitude": 24.983131,
            "longitude": 55.108738
          },
          {
            "latitude": 24.9837,
            "longitude": 55.10683
          },
          {
            "latitude": 24.984215,
            "longitude": 55.105213
          },
          {
            "latitude": 24.986094,
            "longitude": 55.099087
          },
          {
            "latitude": 24.986554,
            "longitude": 55.097504
          },
          {
            "latitude": 24.986741,
            "longitude": 55.096842
          },
          {
            "latitude": 24.986929,
            "longitude": 55.096142
          },
          {
            "latitude": 24.987513,
            "longitude": 55.093824
          },
          {
            "latitude": 24.987629,
            "longitude": 55.09303
          },
          {
            "latitude": 24.985021,
            "longitude": 55.092587
          },
          {
            "latitude": 24.98279,
            "longitude": 55.092127
          },
          {
            "latitude": 24.981155,
            "longitude": 55.091715
          },
          {
            "latitude": 24.978346,
            "longitude": 55.090756
          },
          {
            "latitude": 24.976561,
            "longitude": 55.09
          },
          {
            "latitude": 24.974488,
            "longitude": 55.088995
          },
          {
            "latitude": 24.972327,
            "longitude": 55.087814
          },
          {
            "latitude": 24.969568,
            "longitude": 55.086175
          },
          {
            "latitude": 24.967302,
            "longitude": 55.084877
          },
          {
            "latitude": 24.963982,
            "longitude": 55.082889
          },
          {
            "latitude": 24.959863,
            "longitude": 55.080396
          },
          {
            "latitude": 24.954924,
            "longitude": 55.076399
          },
          {
            "latitude": 24.950457,
            "longitude": 55.070503
          },
          {
            "latitude": 24.948154,
            "longitude": 55.065973
          },
          {
            "latitude": 24.947793,
            "longitude": 55.06497
          },
          {
            "latitude": 24.947348,
            "longitude": 55.06357
          }
        ],
        "freezone": false,
        "id": 6,
        "name": "Jabal Ali Industrial Second",
        "region_id": 1,
        "website": null
      },
      {
        "coordinates": [
          {
            "latitude": 25.017268,
            "longitude": 55.036788
          },
          {
            "latitude": 24.996417,
            "longitude": 55.04551
          },
          {
            "latitude": 24.9932,
            "longitude": 55.040921
          },
          {
            "latitude": 24.982234,
            "longitude": 55.045463
          },
          {
            "latitude": 24.974838,
            "longitude": 55.0369
          },
          {
            "latitude": 24.95936,
            "longitude": 55.050289
          },
          {
            "latitude": 24.960446,
            "longitude": 55.053162
          },
          {
            "latitude": 24.959239,
            "longitude": 55.054542
          },
          {
            "latitude": 24.957431,
            "longitude": 55.052349
          },
          {
            "latitude": 24.951958,
            "longitude": 55.058007
          },
          {
            "latitude": 24.949868,
            "longitude": 55.067149
          },
          {
            "latitude": 24.953991,
            "longitude": 55.074624
          },
          {
            "latitude": 24.962712,
            "longitude": 55.081244
          },
          {
            "latitude": 24.965463,
            "longitude": 55.078437
          },
          {
            "latitude": 24.966981,
            "longitude": 55.080501
          },
          {
            "latitude": 24.964717,
            "longitude": 55.082319
          },
          {
            "latitude": 24.975852,
            "longitude": 55.08887
          },
          {
            "latitude": 24.985895,
            "longitude": 55.092038
          },
          {
            "latitude": 24.988489,
            "longitude": 55.088398
          },
          {
            "latitude": 24.988844,
            "longitude": 55.09109
          },
          {
            "latitude": 24.99108,
            "longitude": 55.092714
          },
          {
            "latitude": 25.005347,
            "longitude": 55.094997
          },
          {
            "latitude": 25.009011,
            "longitude": 55.091269
          },
          {
            "latitude": 25.010419,
            "longitude": 55.08722
          },
          {
            "latitude": 25.014166,
            "longitude": 55.090193
          },
          {
            "latitude": 25.023189,
            "longitude": 55.077701
          },
          {
            "latitude": 25.01384,
            "longitude": 55.067476
          },
          {
            "latitude": 25.016915,
            "longitude": 55.06284
          },
          {
            "latitude": 25.015875,
            "longitude": 55.058338
          },
          {
            "latitude": 25.01281,
            "longitude": 55.055057
          },
          {
            "latitude": 25.015442,
            "longitude": 55.052312
          },
          {
            "latitude": 25.015101,
            "longitude": 55.049913
          },
          {
            "latitude": 25.019196,
            "longitude": 55.048206
          },
          {
            "latitude": 25.019423,
            "longitude": 55.046698
          },
          {
            "latitude": 25.005581,
            "longitude": 55.05243
          },
          {
            "latitude": 25.002611,
            "longitude": 55.05045
          },
          {
            "latitude": 24.994768,
            "longitude": 55.054717
          },
          {
            "latitude": 25.008572,
            "longitude": 55.071742
          },
          {
            "latitude": 25.004618,
            "longitude": 55.075873
          },
          {
            "latitude": 24.988889,
            "longitude": 55.05766
          },
          {
            "latitude": 24.981836,
            "longitude": 55.060595
          },
          {
            "latitude": 24.997696,
            "longitude": 55.079011
          },
          {
            "latitude": 24.994957,
            "longitude": 55.081883
          },
          {
            "latitude": 24.971894,
            "longitude": 55.055366
          },
          {
            "latitude": 24.975951,
            "longitude": 55.049073
          },
          {
            "latitude": 24.981344,
            "longitude": 55.054919
          },
          {
            "latitude": 25.00133,
            "longitude": 55.046697
          },
          {
            "latitude": 25.002782,
            "longitude": 55.043311
          },
          {
            "latitude": 25.004962,
            "longitude": 55.042575
          },
          {
            "latitude": 25.005587,
            "longitude": 55.043909
          },
          {
            "latitude": 25.005757,
            "longitude": 55.041817
          },
          {
            "latitude": 25.017228,
            "longitude": 55.037036
          },
          {
            "latitude": 25.020514,
            "longitude": 55.038331
          }
        ],
        "freezone": true,
        "id": 7,
        "name": "Jebel Ali Freezone",
        "region_id": 1,
        "website": "https://www.jafza.ae/"
      },
      {
        "coordinates": [
          {
            "latitude": 24.927207981413737,
            "longitude": 55.05633554361813
          },
          {
            "latitude": 24.97715893714925,
            "longitude": 55.104572620862804
          },
          {
            "latitude": 24.990074345610832,
            "longitude": 55.10547872475894
          },
          {
            "latitude": 25.01640611665573,
            "longitude": 55.14247318155505
          },
          {
            "latitude": 25.041330458987797,
            "longitude": 55.116663269518895
          },
          {
            "latitude": 25.03112079946152,
            "longitude": 55.08439447883258
          },
          {
            "latitude": 24.998117489421983,
            "longitude": 55.05252355279592
          },
          {
            "latitude": 24.94852010021942,
            "longitude": 55.03426619854374
          }
        ],
        "freezone": false,
        "id": 8,
        "name": "Jabal Ali Second",
        "region_id": 1,
        "website": null
      },
      {
        "coordinates": [
          {
            "latitude": 25.122328,
            "longitude": 55.203753
          },
          {
            "latitude": 25.121297,
            "longitude": 55.204421
          },
          {
            "latitude": 25.118065,
            "longitude": 55.209338
          },
          {
            "latitude": 25.112315,
            "longitude": 55.218353
          },
          {
            "latitude": 25.104412,
            "longitude": 55.230275
          },
          {
            "latitude": 25.106632,
            "longitude": 55.232221
          },
          {
            "latitude": 25.120211,
            "longitude": 55.244293
          },
          {
            "latitude": 25.127844,
            "longitude": 55.251071
          },
          {
            "latitude": 25.136557,
            "longitude": 55.258615
          },
          {
            "latitude": 25.138699,
            "longitude": 55.257461
          },
          {
            "latitude": 25.138627,
            "longitude": 55.257303
          },
          {
            "latitude": 25.135199,
            "longitude": 55.254051
          },
          {
            "latitude": 25.137304,
            "longitude": 55.250989
          },
          {
            "latitude": 25.139375,
            "longitude": 55.248059
          },
          {
            "latitude": 25.140277,
            "longitude": 55.246603
          },
          {
            "latitude": 25.141237,
            "longitude": 55.247411
          },
          {
            "latitude": 25.142441,
            "longitude": 55.248416
          },
          {
            "latitude": 25.14373,
            "longitude": 55.249247
          },
          {
            "latitude": 25.14431,
            "longitude": 55.25016
          },
          {
            "latitude": 25.145664,
            "longitude": 55.249834
          },
          {
            "latitude": 25.147565,
            "longitude": 55.246943
          },
          {
            "latitude": 25.150117,
            "longitude": 55.243159
          },
          {
            "latitude": 25.152192,
            "longitude": 55.240001
          },
          {
            "latitude": 25.154148,
            "longitude": 55.236924
          },
          {
            "latitude": 25.158029,
            "longitude": 55.230561
          },
          {
            "latitude": 25.148792,
            "longitude": 55.224418
          },
          {
            "latitude": 25.140776,
            "longitude": 55.219119
          },
          {
            "latitude": 25.134755,
            "longitude": 55.215684
          },
          {
            "latitude": 25.132711,
            "longitude": 55.214453
          },
          {
            "latitude": 25.132012,
            "longitude": 55.213923
          },
          {
            "latitude": 25.130523,
            "longitude": 55.212796
          },
          {
            "latitude": 25.127518,
            "longitude": 55.209482
          },
          {
            "latitude": 25.12377,
            "longitude": 55.204123
          }
        ],
        "freezone": false,
        "id": 9,
        "name": "Al Quoz",
        "region_id": 1,
        "website": null
      },
      {
        "coordinates": [
          {
            "latitude": 25.297766,
            "longitude": 55.376706
          },
          {
            "latitude": 25.298198,
            "longitude": 55.382588
          },
          {
            "latitude": 25.295723,
            "longitude": 55.388417
          },
          {
            "latitude": 25.281441,
            "longitude": 55.378418
          },
          {
            "latitude": 25.270951,
            "longitude": 55.396292
          },
          {
            "latitude": 25.280844,
            "longitude": 55.396679
          },
          {
            "latitude": 25.284665,
            "longitude": 55.398317
          },
          {
            "latitude": 25.288473,
            "longitude": 55.400923
          },
          {
            "latitude": 25.281472,
            "longitude": 55.413067
          },
          {
            "latitude": 25.278503,
            "longitude": 55.422266
          },
          {
            "latitude": 25.286871,
            "longitude": 55.427893
          },
          {
            "latitude": 25.302612,
            "longitude": 55.386351
          },
          {
            "latitude": 25.297864,
            "longitude": 55.377178
          }
        ],
        "freezone": false,
        "id": 10,
        "name": "Al Qusais Industrial Area",
        "region_id": 1,
        "website": null
      },
      {
        "coordinates": [
          {
            "latitude": 25.210538,
            "longitude": 55.221264
          },
          {
            "latitude": 25.239013,
            "longitude": 55.277148
          },
          {
            "latitude": 25.253915,
            "longitude": 55.279611
          },
          {
            "latitude": 25.261385,
            "longitude": 55.321057
          },
          {
            "latitude": 25.30811,
            "longitude": 55.29725
          },
          {
            "latitude": 25.316898,
            "longitude": 55.262603
          },
          {
            "latitude": 25.298085,
            "longitude": 55.22568
          },
          {
            "latitude": 25.250491,
            "longitude": 55.200907
          }
        ],
        "freezone": false,
        "id": 11,
        "name": "Dubai Maritime City",
        "region_id": 1,
        "website": "https://dubaimaritimecity.com/"
      },
      {
        "coordinates": [
          {
            "latitude": 25.124523,
            "longitude": 55.328665
          },
          {
            "latitude": 25.158756,
            "longitude": 55.364114
          },
          {
            "latitude": 25.169632,
            "longitude": 55.363398
          },
          {
            "latitude": 25.185653,
            "longitude": 55.391967
          },
          {
            "latitude": 25.211463,
            "longitude": 55.367042
          },
          {
            "latitude": 25.208388,
            "longitude": 55.340652
          },
          {
            "latitude": 25.18577,
            "longitude": 55.31723
          },
          {
            "latitude": 25.146593,
            "longitude": 55.307353
          }
        ],
        "freezone": false,
        "id": 12,
        "name": "Ras Al Khor Industrial Area",
        "region_id": 1,
        "website": null
      },
      {
        "coordinates": [
          {
            "latitude": 25.119936,
            "longitude": 55.364883
          },
          {
            "latitude": 25.117539,
            "longitude": 55.366982
          },
          {
            "latitude": 25.115614,
            "longitude": 55.368598
          },
          {
            "latitude": 25.108526,
            "longitude": 55.374496
          },
          {
            "latitude": 25.107459,
            "longitude": 55.375516
          },
          {
            "latitude": 25.1065,
            "longitude": 55.376449
          },
          {
            "latitude": 25.105001,
            "longitude": 55.377662
          },
          {
            "latitude": 25.103777,
            "longitude": 55.37866
          },
          {
            "latitude": 25.105783,
            "longitude": 55.381894
          },
          {
            "latitude": 25.106546,
            "longitude": 55.383096
          },
          {
            "latitude": 25.107087,
            "longitude": 55.383869
          },
          {
            "latitude": 25.109412,
            "longitude": 55.387011
          },
          {
            "latitude": 25.111553,
            "longitude": 55.39002
          },
          {
            "latitude": 25.113271,
            "longitude": 55.392292
          },
          {
            "latitude": 25.119084,
            "longitude": 55.400113
          },
          {
            "latitude": 25.123299,
            "longitude": 55.405783
          },
          {
            "latitude": 25.125167,
            "longitude": 55.408344
          },
          {
            "latitude": 25.125204,
            "longitude": 55.408309
          },
          {
            "latitude": 25.126452,
            "longitude": 55.407117
          },
          {
            "latitude": 25.127781,
            "longitude": 55.405904
          },
          {
            "latitude": 25.12826,
            "longitude": 55.405467
          },
          {
            "latitude": 25.128716,
            "longitude": 55.405017
          },
          {
            "latitude": 25.129287,
            "longitude": 55.404385
          },
          {
            "latitude": 25.129312,
            "longitude": 55.404358
          },
          {
            "latitude": 25.129692,
            "longitude": 55.403863
          },
          {
            "latitude": 25.129733,
            "longitude": 55.40381
          },
          {
            "latitude": 25.130162,
            "longitude": 55.403182
          },
          {
            "latitude": 25.130716,
            "longitude": 55.40215
          },
          {
            "latitude": 25.130729,
            "longitude": 55.402126
          },
          {
            "latitude": 25.131834,
            "longitude": 55.399461
          },
          {
            "latitude": 25.131938,
            "longitude": 55.399196
          },
          {
            "latitude": 25.132926,
            "longitude": 55.396695
          },
          {
            "latitude": 25.133955,
            "longitude": 55.394089
          },
          {
            "latitude": 25.134159,
            "longitude": 55.393575
          },
          {
            "latitude": 25.134898,
            "longitude": 55.391701
          },
          {
            "latitude": 25.135847,
            "longitude": 55.389299
          },
          {
            "latitude": 25.135981,
            "longitude": 55.388962
          },
          {
            "latitude": 25.136163,
            "longitude": 55.388502
          },
          {
            "latitude": 25.137092,
            "longitude": 55.386167
          },
          {
            "latitude": 25.137394,
            "longitude": 55.385409
          },
          {
            "latitude": 25.138057,
            "longitude": 55.383693
          },
          {
            "latitude": 25.138728,
            "longitude": 55.381955
          },
          {
            "latitude": 25.138715,
            "longitude": 55.381949
          },
          {
            "latitude": 25.136585,
            "longitude": 55.380915
          },
          {
            "latitude": 25.135711,
            "longitude": 55.380448
          },
          {
            "latitude": 25.133812,
            "longitude": 55.379291
          },
          {
            "latitude": 25.132544,
            "longitude": 55.378427
          },
          {
            "latitude": 25.132003,
            "longitude": 55.378058
          },
          {
            "latitude": 25.129772,
            "longitude": 55.37631
          },
          {
            "latitude": 25.128977,
            "longitude": 55.375638
          },
          {
            "latitude": 25.128906,
            "longitude": 55.375578
          },
          {
            "latitude": 25.128061,
            "longitude": 55.374811
          },
          {
            "latitude": 25.127334,
            "longitude": 55.374106
          },
          {
            "latitude": 25.126883,
            "longitude": 55.373669
          },
          {
            "latitude": 25.126847,
            "longitude": 55.373633
          },
          {
            "latitude": 25.12528,
            "longitude": 55.37196
          },
          {
            "latitude": 25.125263,
            "longitude": 55.371939
          },
          {
            "latitude": 25.124449,
            "longitude": 55.370925
          },
          {
            "latitude": 25.122489,
            "longitude": 55.368484
          },
          {
            "latitude": 25.120922,
            "longitude": 55.366259
          }
        ],
        "freezone": false,
        "id": 13,
        "name": "Dubai Silicon Oasis",
        "region_id": 1,
        "website": "https://www.dso.ae/"
      }
    ],
    "name": "Dubai"
  },
  {
    "country_id": 1,
    "id": 2,
    "industrial_areas": [
      {
        "coordinates": [
          {
            "latitude": 25.314978,
            "longitude": 55.383062
          },
          {
            "latitude": 25.314685,
            "longitude": 55.383408
          },
          {
            "latitude": 25.314134,
            "longitude": 55.38406
          },
          {
            "latitude": 25.31355,
            "longitude": 55.383586
          },
          {
            "latitude": 25.313361,
            "longitude": 55.383826
          },
          {
            "latitude": 25.313203,
            "longitude": 55.384032
          },
          {
            "latitude": 25.313014,
            "longitude": 55.384276
          },
          {
            "latitude": 25.310801,
            "longitude": 55.387142
          },
          {
            "latitude": 25.30828,
            "longitude": 55.390409
          },
          {
            "latitude": 25.321971,
            "longitude": 55.402977
          },
          {
            "latitude": 25.322234,
            "longitude": 55.403039
          },
          {
            "latitude": 25.322515,
            "longitude": 55.402959
          },
          {
            "latitude": 25.326875,
            "longitude": 55.397534
          },
          {
            "latitude": 25.327063,
            "longitude": 55.397095
          },
          {
            "latitude": 25.327153,
            "longitude": 55.396481
          },
          {
            "latitude": 25.327273,
            "longitude": 55.3959
          },
          {
            "latitude": 25.327407,
            "longitude": 55.395441
          },
          {
            "latitude": 25.327633,
            "longitude": 55.394963
          },
          {
            "latitude": 25.327641,
            "longitude": 55.394826
          },
          {
            "latitude": 25.327603,
            "longitude": 55.3947
          },
          {
            "latitude": 25.327548,
            "longitude": 55.394627
          },
          {
            "latitude": 25.327369,
            "longitude": 55.394425
          },
          {
            "latitude": 25.327057,
            "longitude": 55.394142
          },
          {
            "latitude": 25.326214,
            "longitude": 55.39334
          },
          {
            "latitude": 25.321786,
            "longitude": 55.389239
          },
          {
            "latitude": 25.319148,
            "longitude": 55.386777
          },
          {
            "latitude": 25.317797,
            "longitude": 55.385508
          },
          {
            "latitude": 25.316483,
            "longitude": 55.384312
          },
          {
            "latitude": 25.315065,
            "longitude": 55.383141
          }
        ],
        "freezone": false,
        "id": 14,
        "name": "Sharjah Industrial Area (SIA)",
        "region_id": 2,
        "website": null
      },
      {
        "coordinates": [
          {
            "latitude": 25.331107,
            "longitude": 55.473307
          },
          {
            "latitude": 25.328771,
            "longitude": 55.478187
          },
          {
            "latitude": 25.321625,
            "longitude": 55.504112
          },
          {
            "latitude": 25.323395,
            "longitude": 55.505558
          },
          {
            "latitude": 25.326069,
            "longitude": 55.507436
          },
          {
            "latitude": 25.331404,
            "longitude": 55.498273
          },
          {
            "latitude": 25.332725,
            "longitude": 55.499031
          },
          {
            "latitude": 25.332939,
            "longitude": 55.498072
          },
          {
            "latitude": 25.332221,
            "longitude": 55.497565
          },
          {
            "latitude": 25.332498,
            "longitude": 55.497078
          },
          {
            "latitude": 25.333221,
            "longitude": 55.497583
          },
          {
            "latitude": 25.334491,
            "longitude": 55.495793
          },
          {
            "latitude": 25.338173,
            "longitude": 55.489144
          },
          {
            "latitude": 25.344014,
            "longitude": 55.493113
          },
          {
            "latitude": 25.343505,
            "longitude": 55.494383
          },
          {
            "latitude": 25.346683,
            "longitude": 55.496584
          },
          {
            "latitude": 25.349102,
            "longitude": 55.492351
          },
          {
            "latitude": 25.34725,
            "longitude": 55.490997
          },
          {
            "latitude": 25.34965,
            "longitude": 55.486956
          },
          {
            "latitude": 25.338576,
            "longitude": 55.478807
          }
        ],
        "freezone": true,
        "id": 15,
        "name": "Saif Zone",
        "region_id": 2,
        "website": "https://www.saif-zone.com/"
      },
      {
        "coordinates": [
          {
            "latitude": 25.301119,
            "longitude": 55.59807
          },
          {
            "latitude": 25.343087,
            "longitude": 55.64468
          },
          {
            "latitude": 25.355265,
            "longitude": 55.645772
          },
          {
            "latitude": 25.376062,
            "longitude": 55.681302
          },
          {
            "latitude": 25.402726,
            "longitude": 55.657294
          },
          {
            "latitude": 25.396719,
            "longitude": 55.626532
          },
          {
            "latitude": 25.36899,
            "longitude": 55.595736
          },
          {
            "latitude": 25.323919,
            "longitude": 55.577541
          }
        ],
        "freezone": false,
        "id": 16,
        "name": "Al Saja'a Industrial Oasis",
        "region_id": 2,
        "website": "https://www.asio.ae/home/main"
      },
      {
        "coordinates": [
          {
            "latitude": 25.482437,
            "longitude": 55.489451
          },
          {
            "latitude": 25.47005,
            "longitude": 55.494749
          },
          {
            "latitude": 25.463347,
            "longitude": 55.507149
          },
          {
            "latitude": 25.470559,
            "longitude": 55.511877
          },
          {
            "latitude": 25.471445,
            "longitude": 55.510273
          },
          {
            "latitude": 25.470903,
            "longitude": 55.509909
          },
          {
            "latitude": 25.471183,
            "longitude": 55.509383
          },
          {
            "latitude": 25.466829,
            "longitude": 55.50654
          },
          {
            "latitude": 25.468689,
            "longitude": 55.503123
          },
          {
            "latitude": 25.471784,
            "longitude": 55.50514
          },
          {
            "latitude": 25.472937,
            "longitude": 55.50301
          },
          {
            "latitude": 25.469842,
            "longitude": 55.500977
          },
          {
            "latitude": 25.472719,
            "longitude": 55.495613
          },
          {
            "latitude": 25.481619,
            "longitude": 55.491903
          },
          {
            "latitude": 25.475518,
            "longitude": 55.494663
          },
          {
            "latitude": 25.474239,
            "longitude": 55.49668
          },
          {
            "latitude": 25.474548,
            "longitude": 55.499181
          },
          {
            "latitude": 25.476229,
            "longitude": 55.500733
          },
          {
            "latitude": 25.477452,
            "longitude": 55.503308
          },
          {
            "latitude": 25.476689,
            "longitude": 55.502278
          },
          {
            "latitude": 25.47651,
            "longitude": 55.503115
          },
          {
            "latitude": 25.477651,
            "longitude": 55.505706
          },
          {
            "latitude": 25.477963,
            "longitude": 55.50886
          },
          {
            "latitude": 25.476203,
            "longitude": 55.512631
          },
          {
            "latitude": 25.472163,
            "longitude": 55.516584
          },
          {
            "latitude": 25.47085,
            "longitude": 55.516367
          },
          {
            "latitude": 25.469843,
            "longitude": 55.517881
          },
          {
            "latitude": 25.471108,
            "longitude": 55.519026
          },
          {
            "latitude": 25.472591,
            "longitude": 55.517176
          },
          {
            "latitude": 25.473428,
            "longitude": 55.517505
          },
          {
            "latitude": 25.476266,
            "longitude": 55.51604
          },
          {
            "latitude": 25.479479,
            "longitude": 55.512173
          },
          {
            "latitude": 25.480486,
            "longitude": 55.50743
          },
          {
            "latitude": 25.47937,
            "longitude": 55.502849
          },
          {
            "latitude": 25.476084,
            "longitude": 55.49804
          },
          {
            "latitude": 25.476074,
            "longitude": 55.496603
          },
          {
            "latitude": 25.47684,
            "longitude": 55.495592
          },
          {
            "latitude": 25.481489,
            "longitude": 55.493687
          }
        ],
        "freezone": true,
        "id": 17,
        "name": "Hamriya Free Zone",
        "region_id": 2,
        "website": "https://hfza.ae/"
      }
    ],
    "name": "Sharjah"
  },
  {
    "country_id": 1,
    "id": 3,
    "industrial_areas": [
      {
        "coordinates": [
          {
            "latitude": 25.406463,
            "longitude": 55.451576
          },
          {
            "latitude": 25.405936,
            "longitude": 55.451627
          },
          {
            "latitude": 25.405327,
            "longitude": 55.451657
          },
          {
            "latitude": 25.40474,
            "longitude": 55.451799
          },
          {
            "latitude": 25.404156,
            "longitude": 55.451924
          },
          {
            "latitude": 25.403626,
            "longitude": 55.452037
          },
          {
            "latitude": 25.401581,
            "longitude": 55.452532
          },
          {
            "latitude": 25.400045,
            "longitude": 55.453038
          },
          {
            "latitude": 25.399159,
            "longitude": 55.453214
          },
          {
            "latitude": 25.398868,
            "longitude": 55.453265
          },
          {
            "latitude": 25.398086,
            "longitude": 55.453664
          },
          {
            "latitude": 25.397653,
            "longitude": 55.45397
          },
          {
            "latitude": 25.396894,
            "longitude": 55.454521
          },
          {
            "latitude": 25.396301,
            "longitude": 55.45525
          },
          {
            "latitude": 25.395496,
            "longitude": 55.456522
          },
          {
            "latitude": 25.395391,
            "longitude": 55.456884
          },
          {
            "latitude": 25.395087,
            "longitude": 55.459243
          },
          {
            "latitude": 25.394722,
            "longitude": 55.462212
          },
          {
            "latitude": 25.394342,
            "longitude": 55.465036
          },
          {
            "latitude": 25.394075,
            "longitude": 55.467291
          },
          {
            "latitude": 25.394028,
            "longitude": 55.467649
          },
          {
            "latitude": 25.398982,
            "longitude": 55.468291
          },
          {
            "latitude": 25.399032,
            "longitude": 55.467901
          },
          {
            "latitude": 25.399238,
            "longitude": 55.466169
          },
          {
            "latitude": 25.399446,
            "longitude": 55.464597
          },
          {
            "latitude": 25.397852,
            "longitude": 55.464351
          },
          {
            "latitude": 25.397638,
            "longitude": 55.465974
          },
          {
            "latitude": 25.396467,
            "longitude": 55.465865
          },
          {
            "latitude": 25.396429,
            "longitude": 55.464371
          },
          {
            "latitude": 25.396471,
            "longitude": 55.461344
          },
          {
            "latitude": 25.39681,
            "longitude": 55.457679
          },
          {
            "latitude": 25.396991,
            "longitude": 55.457013
          },
          {
            "latitude": 25.397276,
            "longitude": 55.455985
          },
          {
            "latitude": 25.398056,
            "longitude": 55.4549
          },
          {
            "latitude": 25.399151,
            "longitude": 55.454443
          },
          {
            "latitude": 25.401197,
            "longitude": 55.45431
          },
          {
            "latitude": 25.402597,
            "longitude": 55.454272
          },
          {
            "latitude": 25.405785,
            "longitude": 55.454719
          },
          {
            "latitude": 25.409735,
            "longitude": 55.455252
          },
          {
            "latitude": 25.412305,
            "longitude": 55.455643
          },
          {
            "latitude": 25.414132,
            "longitude": 55.455804
          },
          {
            "latitude": 25.416788,
            "longitude": 55.456195
          },
          {
            "latitude": 25.417094,
            "longitude": 55.453005
          },
          {
            "latitude": 25.4113,
            "longitude": 55.45214
          },
          {
            "latitude": 25.408108,
            "longitude": 55.451689
          },
          {
            "latitude": 25.407296,
            "longitude": 55.45161
          }
        ],
        "freezone": true,
        "id": 18,
        "name": "Ajman Free Zone",
        "region_id": 3,
        "website": "https://afz.gov.ae/en.html"
      },
      {
        "coordinates": [
          {
            "latitude": 25.375861,
            "longitude": 55.457675
          },
          {
            "latitude": 25.375492,
            "longitude": 55.45842
          },
          {
            "latitude": 25.371258,
            "longitude": 55.467068
          },
          {
            "latitude": 25.364828,
            "longitude": 55.480181
          },
          {
            "latitude": 25.365015,
            "longitude": 55.480428
          },
          {
            "latitude": 25.365462,
            "longitude": 55.481019
          },
          {
            "latitude": 25.366151,
            "longitude": 55.481761
          },
          {
            "latitude": 25.368608,
            "longitude": 55.48398
          },
          {
            "latitude": 25.370379,
            "longitude": 55.48578
          },
          {
            "latitude": 25.374015,
            "longitude": 55.489057
          },
          {
            "latitude": 25.376768,
            "longitude": 55.491701
          },
          {
            "latitude": 25.379616,
            "longitude": 55.494131
          },
          {
            "latitude": 25.381026,
            "longitude": 55.495564
          },
          {
            "latitude": 25.381387,
            "longitude": 55.495931
          },
          {
            "latitude": 25.382262,
            "longitude": 55.495813
          },
          {
            "latitude": 25.386151,
            "longitude": 55.495336
          },
          {
            "latitude": 25.389845,
            "longitude": 55.494754
          },
          {
            "latitude": 25.395073,
            "longitude": 55.494092
          },
          {
            "latitude": 25.396466,
            "longitude": 55.493915
          },
          {
            "latitude": 25.396335,
            "longitude": 55.493259
          },
          {
            "latitude": 25.395674,
            "longitude": 55.490214
          },
          {
            "latitude": 25.395013,
            "longitude": 55.487307
          },
          {
            "latitude": 25.394218,
            "longitude": 55.483524
          },
          {
            "latitude": 25.393078,
            "longitude": 55.478958
          },
          {
            "latitude": 25.391936,
            "longitude": 55.474161
          },
          {
            "latitude": 25.391524,
            "longitude": 55.471882
          },
          {
            "latitude": 25.390375,
            "longitude": 55.471114
          },
          {
            "latitude": 25.388106,
            "longitude": 55.468942
          },
          {
            "latitude": 25.384755,
            "longitude": 55.465839
          },
          {
            "latitude": 25.381861,
            "longitude": 55.463092
          },
          {
            "latitude": 25.379274,
            "longitude": 55.460812
          },
          {
            "latitude": 25.376096,
            "longitude": 55.457887
          }
        ],
        "freezone": false,
        "id": 19,
        "name": "Ajman Industrial 1",
        "region_id": 3,
        "website": null
      },
      {
        "coordinates": [
          {
            "latitude": 25.381641,
            "longitude": 55.527182
          },
          {
            "latitude": 25.408998,
            "longitude": 55.559785
          },
          {
            "latitude": 25.41928,
            "longitude": 55.559095
          },
          {
            "latitude": 25.430493,
            "longitude": 55.585402
          },
          {
            "latitude": 25.457979,
            "longitude": 55.562338
          },
          {
            "latitude": 25.458603,
            "longitude": 55.538004
          },
          {
            "latitude": 25.440528,
            "longitude": 55.516463
          },
          {
            "latitude": 25.405143,
            "longitude": 55.507461
          }
        ],
        "freezone": false,
        "id": 20,
        "name": "Al Jerf Industrial",
        "region_id": 3,
        "website": null
      },
      {
        "coordinates": [
          {
            "latitude": 25.360214157099698,
            "longitude": 55.4022201336306
          },
          {
            "latitude": 25.34610522697125,
            "longitude": 55.46333262409393
          },
          {
            "latitude": 25.35344361814627,
            "longitude": 55.47422250999611
          },
          {
            "latitude": 25.335019639013186,
            "longitude": 55.511349580886545
          },
          {
            "latitude": 25.375358559695293,
            "longitude": 55.520662554536386
          },
          {
            "latitude": 25.399528527241063,
            "longitude": 55.49865557680575
          },
          {
            "latitude": 25.408850498933074,
            "longitude": 55.45827768132105
          },
          {
            "latitude": 25.394706857393096,
            "longitude": 55.410183400954374
          }
        ],
        "freezone": false,
        "id": 21,
        "name": "Ajman Industrial 2",
        "region_id": 3,
        "website": null
      }
    ],
    "name": "Ajman"
  },
  {
    "country_id": 1,
    "id": 4,
    "industrial_areas": [
      {
        "coordinates": [
          {
            "latitude": 25.504904,
            "longitude": 55.535105
          },
          {
            "latitude": 25.502164,
            "longitude": 55.537793
          },
          {
            "latitude": 25.498197,
            "longitude": 55.541686
          },
          {
            "latitude": 25.496612,
            "longitude": 55.543242
          },
          {
            "latitude": 25.495008,
            "longitude": 55.544816
          },
          {
            "latitude": 25.494288,
            "longitude": 55.545523
          },
          {
            "latitude": 25.493638,
            "longitude": 55.54616
          },
          {
            "latitude": 25.493072,
            "longitude": 55.546715
          },
          {
            "latitude": 25.493203,
            "longitude": 55.547051
          },
          {
            "latitude": 25.493768,
            "longitude": 55.548482
          },
          {
            "latitude": 25.494103,
            "longitude": 55.549681
          },
          {
            "latitude": 25.494079,
            "longitude": 55.551105
          },
          {
            "latitude": 25.494042,
            "longitude": 55.552308
          },
          {
            "latitude": 25.494017,
            "longitude": 55.553105
          },
          {
            "latitude": 25.494081,
            "longitude": 55.555417
          },
          {
            "latitude": 25.494156,
            "longitude": 55.556787
          },
          {
            "latitude": 25.494431,
            "longitude": 55.557816
          },
          {
            "latitude": 25.494808,
            "longitude": 55.558823
          },
          {
            "latitude": 25.496065,
            "longitude": 55.562289
          },
          {
            "latitude": 25.49692,
            "longitude": 55.564278
          },
          {
            "latitude": 25.497546,
            "longitude": 55.56573
          },
          {
            "latitude": 25.497901,
            "longitude": 55.566602
          },
          {
            "latitude": 25.498609,
            "longitude": 55.56821
          },
          {
            "latitude": 25.498881,
            "longitude": 55.568948
          },
          {
            "latitude": 25.499201,
            "longitude": 55.570007
          },
          {
            "latitude": 25.499957,
            "longitude": 55.569702
          },
          {
            "latitude": 25.500963,
            "longitude": 55.569303
          },
          {
            "latitude": 25.50191,
            "longitude": 55.568928
          },
          {
            "latitude": 25.503081,
            "longitude": 55.568464
          },
          {
            "latitude": 25.504262,
            "longitude": 55.567996
          },
          {
            "latitude": 25.505948,
            "longitude": 55.567246
          },
          {
            "latitude": 25.507497,
            "longitude": 55.566556
          },
          {
            "latitude": 25.5098,
            "longitude": 55.565531
          },
          {
            "latitude": 25.511729,
            "longitude": 55.564671
          },
          {
            "latitude": 25.513191,
            "longitude": 55.56402
          },
          {
            "latitude": 25.514233,
            "longitude": 55.563564
          },
          {
            "latitude": 25.513491,
            "longitude": 55.561149
          },
          {
            "latitude": 25.513158,
            "longitude": 55.560115
          },
          {
            "latitude": 25.51266,
            "longitude": 55.558595
          },
          {
            "latitude": 25.512373,
            "longitude": 55.557748
          },
          {
            "latitude": 25.511244,
            "longitude": 55.554293
          },
          {
            "latitude": 25.510144,
            "longitude": 55.550905
          },
          {
            "latitude": 25.509208,
            "longitude": 55.54809
          },
          {
            "latitude": 25.508948,
            "longitude": 55.547088
          },
          {
            "latitude": 25.507916,
            "longitude": 55.544006
          },
          {
            "latitude": 25.506771,
            "longitude": 55.540651
          },
          {
            "latitude": 25.505832,
            "longitude": 55.538081
          },
          {
            "latitude": 25.505501,
            "longitude": 55.536729
          }
        ],
        "freezone": false,
        "id": 22,
        "name": "Al Raafah",
        "region_id": 4,
        "website": "https://ia.uaq.ae/"
      }
    ],
    "name": "Umm Al Quwain"
  },
  {
    "country_id": 1,
    "id": 5,
    "industrial_areas": [
      {
        "coordinates": [
          {
            "latitude": 25.605718,
            "longitude": 55.681979
          },
          {
            "latitude": 25.630603,
            "longitude": 55.746806
          },
          {
            "latitude": 25.645511,
            "longitude": 55.75171
          },
          {
            "latitude": 25.650156,
            "longitude": 55.797743
          },
          {
            "latitude": 25.699113,
            "longitude": 55.77895
          },
          {
            "latitude": 25.710443,
            "longitude": 55.742723
          },
          {
            "latitude": 25.694001,
            "longitude": 55.699891
          },
          {
            "latitude": 25.64758,
            "longitude": 55.665909
          }
        ],
        "freezone": false,
        "id": 23,
        "name": "Al Jazeera Al Hamra Industrial",
        "region_id": 5,
        "website": "https://rakez.com/en/about/zones/zone-detail/al-hamra-industrial-zone"
      },
      {
        "coordinates": [
          {
            "latitude": 25.877978,
            "longitude": 56.019981
          },
          {
            "latitude": 25.912455,
            "longitude": 56.064109
          },
          {
            "latitude": 25.923937,
            "longitude": 56.065291
          },
          {
            "latitude": 25.939544,
            "longitude": 56.098782
          },
          {
            "latitude": 25.967818,
            "longitude": 56.076692
          },
          {
            "latitude": 25.965745,
            "longitude": 56.047855
          },
          {
            "latitude": 25.942965,
            "longitude": 56.018699
          },
          {
            "latitude": 25.902154,
            "longitude": 56.001092
          }
        ],
        "freezone": false,
        "id": 24,
        "name": "Al Hulaila Industrial zone",
        "region_id": 5,
        "website": "https://rakez.com/en/about/zones/zone-detail/al-hulaila-industrial-zone"
      },
      {
        "coordinates": [
          {
            "latitude": 25.39164,
            "longitude": 55.962544
          },
          {
            "latitude": 25.390683,
            "longitude": 55.962551
          },
          {
            "latitude": 25.390278,
            "longitude": 55.962554
          },
          {
            "latitude": 25.384174,
            "longitude": 55.962603
          },
          {
            "latitude": 25.384435,
            "longitude": 55.972174
          },
          {
            "latitude": 25.384173,
            "longitude": 55.972174
          },
          {
            "latitude": 25.381568,
            "longitude": 55.972273
          },
          {
            "latitude": 25.381625,
            "longitude": 55.977277
          },
          {
            "latitude": 25.379087,
            "longitude": 55.977229
          },
          {
            "latitude": 25.379091,
            "longitude": 55.978333
          },
          {
            "latitude": 25.376564,
            "longitude": 55.978375
          },
          {
            "latitude": 25.376573,
            "longitude": 55.979296
          },
          {
            "latitude": 25.379094,
            "longitude": 55.979207
          },
          {
            "latitude": 25.381647,
            "longitude": 55.979236
          },
          {
            "latitude": 25.381691,
            "longitude": 55.983096
          },
          {
            "latitude": 25.381731,
            "longitude": 55.983095
          },
          {
            "latitude": 25.381779,
            "longitude": 55.988941
          },
          {
            "latitude": 25.383244,
            "longitude": 55.989743
          },
          {
            "latitude": 25.383122,
            "longitude": 55.983071
          },
          {
            "latitude": 25.384283,
            "longitude": 55.98305
          },
          {
            "latitude": 25.387011,
            "longitude": 55.983045
          },
          {
            "latitude": 25.387117,
            "longitude": 55.984932
          },
          {
            "latitude": 25.392313,
            "longitude": 55.98739
          },
          {
            "latitude": 25.3927,
            "longitude": 55.990481
          },
          {
            "latitude": 25.392275,
            "longitude": 55.990568
          },
          {
            "latitude": 25.391693,
            "longitude": 55.992607
          },
          {
            "latitude": 25.390984,
            "longitude": 55.998951
          },
          {
            "latitude": 25.394061,
            "longitude": 55.998597
          },
          {
            "latitude": 25.395179,
            "longitude": 55.9983
          },
          {
            "latitude": 25.401555,
            "longitude": 55.995773
          },
          {
            "latitude": 25.400963,
            "longitude": 55.991633
          },
          {
            "latitude": 25.399922,
            "longitude": 55.984365
          },
          {
            "latitude": 25.409868,
            "longitude": 55.984078
          },
          {
            "latitude": 25.409684,
            "longitude": 55.978067
          },
          {
            "latitude": 25.414307,
            "longitude": 55.977107
          },
          {
            "latitude": 25.414307,
            "longitude": 55.975695
          },
          {
            "latitude": 25.409618,
            "longitude": 55.974647
          },
          {
            "latitude": 25.409569,
            "longitude": 55.97092
          },
          {
            "latitude": 25.399225,
            "longitude": 55.971024
          },
          {
            "latitude": 25.399194,
            "longitude": 55.976932
          },
          {
            "latitude": 25.396711,
            "longitude": 55.976853
          },
          {
            "latitude": 25.39636,
            "longitude": 55.972
          },
          {
            "latitude": 25.392015,
            "longitude": 55.97213
          },
          {
            "latitude": 25.392118,
            "longitude": 55.966651
          },
          {
            "latitude": 25.390364,
            "longitude": 55.966657
          },
          {
            "latitude": 25.390343,
            "longitude": 55.972174
          },
          {
            "latitude": 25.388737,
            "longitude": 55.972174
          },
          {
            "latitude": 25.388632,
            "longitude": 55.964575
          },
          {
            "latitude": 25.389668,
            "longitude": 55.964553
          },
          {
            "latitude": 25.390218,
            "longitude": 55.964539
          },
          {
            "latitude": 25.39164,
            "longitude": 55.964505
          },
          {
            "latitude": 25.39164,
            "longitude": 55.963036
          }
        ],
        "freezone": false,
        "id": 25,
        "name": "Al Ghail Industrial zone",
        "region_id": 5,
        "website": "https://rakez.com/en/about/zones/zone-detail/al-ghail-industrial-zone"
      },
      {
        "coordinates": [
          {
            "latitude": 25.844055,
            "longitude": 55.681351
          },
          {
            "latitude": 25.846244,
            "longitude": 55.744033
          },
          {
            "latitude": 25.85743,
            "longitude": 55.752608
          },
          {
            "latitude": 25.847964,
            "longitude": 55.793283
          },
          {
            "latitude": 25.894855,
            "longitude": 55.791645
          },
          {
            "latitude": 25.914984,
            "longitude": 55.764046
          },
          {
            "latitude": 25.913538,
            "longitude": 55.722631
          },
          {
            "latitude": 25.88415,
            "longitude": 55.679951
          }
        ],
        "freezone": false,
        "id": 26,
        "name": "RAK Maritime City",
        "region_id": 5,
        "website": null
      }
    ],
    "name": "Ras Al Khaimah"
  },
  {
    "country_id": 1,
    "id": 6,
    "industrial_areas": [
      {
        "coordinates": [
          {
            "latitude": 24.114913,
            "longitude": 55.715891
          },
          {
            "latitude": 24.130957,
            "longitude": 55.762486
          },
          {
            "latitude": 24.144747,
            "longitude": 55.765183
          },
          {
            "latitude": 24.143563,
            "longitude": 55.799096
          },
          {
            "latitude": 24.193146,
            "longitude": 55.782024
          },
          {
            "latitude": 24.208547,
            "longitude": 55.754384
          },
          {
            "latitude": 24.197946,
            "longitude": 55.723598
          },
          {
            "latitude": 24.15731,
            "longitude": 55.701292
          }
        ],
        "freezone": false,
        "id": 27,
        "name": "Al Ain Industrial City",
        "region_id": 6,
        "website": null
      },
      {
        "coordinates": [
          {
            "latitude": 24.210305,
            "longitude": 55.583645
          },
          {
            "latitude": 24.251121,
            "longitude": 55.639823
          },
          {
            "latitude": 24.263683,
            "longitude": 55.642958
          },
          {
            "latitude": 24.283191,
            "longitude": 55.683963
          },
          {
            "latitude": 24.312218,
            "longitude": 55.662873
          },
          {
            "latitude": 24.307767,
            "longitude": 55.629322
          },
          {
            "latitude": 24.280799,
            "longitude": 55.592204
          },
          {
            "latitude": 24.235126,
            "longitude": 55.565611
          }
        ],
        "freezone": false,
        "id": 28,
        "name": "Nibras Al Ain Aerospace Park",
        "region_id": 6,
        "website": "http://www.nibrasalain.com/"
      },
      {
        "coordinates": [
          {
            "latitude": 24.565485,
            "longitude": 54.832171
          },
          {
            "latitude": 24.549112,
            "longitude": 54.885724
          },
          {
            "latitude": 24.555953,
            "longitude": 54.896182
          },
          {
            "latitude": 24.536247,
            "longitude": 54.927802
          },
          {
            "latitude": 24.575838,
            "longitude": 54.939906
          },
          {
            "latitude": 24.600643,
            "longitude": 54.922393
          },
          {
            "latitude": 24.61146,
            "longitude": 54.88701
          },
          {
            "latitude": 24.599338,
            "longitude": 54.842521
          }
        ],
        "freezone": false,
        "id": 29,
        "name": "Tawazun Industrial Park - TIP",
        "region_id": 6,
        "website": "https://www.tip.ae/"
      },
      {
        "coordinates": [
          {
            "latitude": 24.654254,
            "longitude": 54.766493
          },
          {
            "latitude": 24.657113,
            "longitude": 54.785238
          },
          {
            "latitude": 24.646569,
            "longitude": 54.793768
          },
          {
            "latitude": 24.638505,
            "longitude": 54.793234
          },
          {
            "latitude": 24.624072,
            "longitude": 54.903381
          },
          {
            "latitude": 24.596587,
            "longitude": 54.902225
          },
          {
            "latitude": 24.606402,
            "longitude": 54.993117
          },
          {
            "latitude": 24.615918,
            "longitude": 55.026718
          },
          {
            "latitude": 24.618548,
            "longitude": 55.042492
          },
          {
            "latitude": 24.619324,
            "longitude": 55.054042
          },
          {
            "latitude": 24.61837,
            "longitude": 55.074857
          },
          {
            "latitude": 24.614589,
            "longitude": 55.094577
          },
          {
            "latitude": 24.608044,
            "longitude": 55.113412
          },
          {
            "latitude": 24.601419,
            "longitude": 55.126875
          },
          {
            "latitude": 24.608627,
            "longitude": 55.131105
          },
          {
            "latitude": 24.625912,
            "longitude": 55.139335
          },
          {
            "latitude": 24.636235,
            "longitude": 55.142158
          },
          {
            "latitude": 24.681243,
            "longitude": 55.140151
          },
          {
            "latitude": 24.698873,
            "longitude": 55.097745
          },
          {
            "latitude": 24.658188,
            "longitude": 55.07734
          },
          {
            "latitude": 24.752604,
            "longitude": 54.851674
          },
          {
            "latitude": 24.792898,
            "longitude": 54.874238
          },
          {
            "latitude": 24.797649,
            "longitude": 54.862855
          },
          {
            "latitude": 24.767666,
            "longitude": 54.847664
          },
          {
            "latitude": 24.736485,
            "longitude": 54.824208
          },
          {
            "latitude": 24.730909,
            "longitude": 54.818896
          },
          {
            "latitude": 24.708567,
            "longitude": 54.79271
          },
          {
            "latitude": 24.695888,
            "longitude": 54.803055
          },
          {
            "latitude": 24.688426,
            "longitude": 54.791155
          },
          {
            "latitude": 24.681821,
            "longitude": 54.78241
          },
          {
            "latitude": 24.676598,
            "longitude": 54.780967
          },
          {
            "latitude": 24.675236,
            "longitude": 54.78227
          },
          {
            "latitude": 24.655932,
            "longitude": 54.766611
          }
        ],
        "freezone": false,
        "id": 30,
        "name": "Khalifa Industrial",
        "region_id": 6,
        "website": "https://www.kezadgroup.com/"
      },
      {
        "coordinates": [
          {
            "latitude": 24.321559,
            "longitude": 54.450605
          },
          {
            "latitude": 24.315892,
            "longitude": 54.453285
          },
          {
            "latitude": 24.313502,
            "longitude": 54.458448
          },
          {
            "latitude": 24.31354,
            "longitude": 54.465123
          },
          {
            "latitude": 24.314733,
            "longitude": 54.464668
          },
          {
            "latitude": 24.315223,
            "longitude": 54.467907
          },
          {
            "latitude": 24.314018,
            "longitude": 54.474275
          },
          {
            "latitude": 24.314768,
            "longitude": 54.489161
          },
          {
            "latitude": 24.316003,
            "longitude": 54.490549
          },
          {
            "latitude": 24.314959,
            "longitude": 54.495252
          },
          {
            "latitude": 24.316524,
            "longitude": 54.525744
          },
          {
            "latitude": 24.322497,
            "longitude": 54.525309
          },
          {
            "latitude": 24.323681,
            "longitude": 54.520209
          },
          {
            "latitude": 24.324518,
            "longitude": 54.522539
          },
          {
            "latitude": 24.337687,
            "longitude": 54.521918
          },
          {
            "latitude": 24.338017,
            "longitude": 54.525995
          },
          {
            "latitude": 24.344424,
            "longitude": 54.525452
          },
          {
            "latitude": 24.346301,
            "longitude": 54.521542
          },
          {
            "latitude": 24.348551,
            "longitude": 54.524996
          },
          {
            "latitude": 24.351827,
            "longitude": 54.525493
          },
          {
            "latitude": 24.370455,
            "longitude": 54.524495
          },
          {
            "latitude": 24.374071,
            "longitude": 54.521343
          },
          {
            "latitude": 24.375846,
            "longitude": 54.523967
          },
          {
            "latitude": 24.379415,
            "longitude": 54.524226
          },
          {
            "latitude": 24.379335,
            "longitude": 54.52186
          },
          {
            "latitude": 24.384825,
            "longitude": 54.521141
          },
          {
            "latitude": 24.383361,
            "longitude": 54.517005
          },
          {
            "latitude": 24.383369,
            "longitude": 54.512133
          },
          {
            "latitude": 24.384593,
            "longitude": 54.512096
          },
          {
            "latitude": 24.38298,
            "longitude": 54.505682
          },
          {
            "latitude": 24.383972,
            "longitude": 54.501002
          },
          {
            "latitude": 24.382529,
            "longitude": 54.493832
          },
          {
            "latitude": 24.382633,
            "longitude": 54.468335
          },
          {
            "latitude": 24.378974,
            "longitude": 54.466331
          },
          {
            "latitude": 24.364295,
            "longitude": 54.466913
          },
          {
            "latitude": 24.363084,
            "longitude": 54.465057
          },
          {
            "latitude": 24.364025,
            "longitude": 54.462644
          },
          {
            "latitude": 24.343643,
            "longitude": 54.456673
          },
          {
            "latitude": 24.336046,
            "longitude": 54.457479
          },
          {
            "latitude": 24.333135,
            "longitude": 54.458838
          },
          {
            "latitude": 24.333271,
            "longitude": 54.460929
          },
          {
            "latitude": 24.331135,
            "longitude": 54.46089
          },
          {
            "latitude": 24.333989,
            "longitude": 54.45463
          },
          {
            "latitude": 24.32178,
            "longitude": 54.450754
          }
        ],
        "freezone": false,
        "id": 31,
        "name": "Musaffah Industrial",
        "region_id": 6,
        "website": null
      },
      {
        "coordinates": [
          {
            "latitude": 24.268001,
            "longitude": 54.378031
          },
          {
            "latitude": 24.255804,
            "longitude": 54.384631
          },
          {
            "latitude": 24.247564,
            "longitude": 54.389948
          },
          {
            "latitude": 24.233038,
            "longitude": 54.400245
          },
          {
            "latitude": 24.218136,
            "longitude": 54.412182
          },
          {
            "latitude": 24.213134,
            "longitude": 54.414845
          },
          {
            "latitude": 24.230345,
            "longitude": 54.453411
          },
          {
            "latitude": 24.234775,
            "longitude": 54.460361
          },
          {
            "latitude": 24.265209,
            "longitude": 54.49337
          },
          {
            "latitude": 24.26886,
            "longitude": 54.498605
          },
          {
            "latitude": 24.287897,
            "longitude": 54.552906
          },
          {
            "latitude": 24.291302,
            "longitude": 54.54967
          },
          {
            "latitude": 24.306306,
            "longitude": 54.530895
          },
          {
            "latitude": 24.310032,
            "longitude": 54.528006
          },
          {
            "latitude": 24.315316,
            "longitude": 54.526573
          },
          {
            "latitude": 24.337692,
            "longitude": 54.526523
          },
          {
            "latitude": 24.336347,
            "longitude": 54.493035
          },
          {
            "latitude": 24.345367,
            "longitude": 54.492601
          },
          {
            "latitude": 24.344987,
            "longitude": 54.482747
          },
          {
            "latitude": 24.335967,
            "longitude": 54.483171
          },
          {
            "latitude": 24.335308,
            "longitude": 54.466339
          },
          {
            "latitude": 24.318511,
            "longitude": 54.467149
          },
          {
            "latitude": 24.319191,
            "longitude": 54.484526
          },
          {
            "latitude": 24.313644,
            "longitude": 54.484807
          },
          {
            "latitude": 24.311952,
            "longitude": 54.456275
          },
          {
            "latitude": 24.31297,
            "longitude": 54.453487
          },
          {
            "latitude": 24.314782,
            "longitude": 54.451737
          },
          {
            "latitude": 24.321309,
            "longitude": 54.447528
          },
          {
            "latitude": 24.318812,
            "longitude": 54.44508
          },
          {
            "latitude": 24.297772,
            "longitude": 54.430839
          },
          {
            "latitude": 24.27972,
            "longitude": 54.403078
          }
        ],
        "freezone": false,
        "id": 32,
        "name": "Industrial City Abu Dhabi ICAD",
        "region_id": 6,
        "website": null
      },
      {
        "coordinates": [
          {
            "latitude": 24.268082,
            "longitude": 54.514216
          },
          {
            "latitude": 24.245474,
            "longitude": 54.579872
          },
          {
            "latitude": 24.251322,
            "longitude": 54.592377
          },
          {
            "latitude": 24.227711,
            "longitude": 54.63146
          },
          {
            "latitude": 24.266856,
            "longitude": 54.644938
          },
          {
            "latitude": 24.294132,
            "longitude": 54.622855
          },
          {
            "latitude": 24.309069,
            "longitude": 54.579475
          },
          {
            "latitude": 24.301553,
            "longitude": 54.525741
          }
        ],
        "freezone": false,
        "id": 33,
        "name": "Mafraq Industrial Area",
        "region_id": 6,
        "website": null
      },
      {
        "coordinates": [
          {
            "latitude": 24.102844,
            "longitude": 52.708724
          },
          {
            "latitude": 24.100889,
            "longitude": 52.76469
          },
          {
            "latitude": 24.111484,
            "longitude": 52.773065
          },
          {
            "latitude": 24.099354,
            "longitude": 52.808663
          },
          {
            "latitude": 24.146245,
            "longitude": 52.8103
          },
          {
            "latitude": 24.16815,
            "longitude": 52.787051
          },
          {
            "latitude": 24.169441,
            "longitude": 52.750073
          },
          {
            "latitude": 24.142939,
            "longitude": 52.710124
          }
        ],
        "freezone": false,
        "id": 34,
        "name": "Al Ruwais Industrial City",
        "region_id": 6,
        "website": null
      }
    ],
    "name": "Abu Dhabi"
  },
  {
    "country_id": 1,
    "id": 7,
    "industrial_areas": [
      {
        "coordinates": [
          {
            "latitude": 25.043931,
            "longitude": 56.244449
          },
          {
            "latitude": 25.054946,
            "longitude": 56.285559
          },
          {
            "latitude": 25.068265,
            "longitude": 56.288284
          },
          {
            "latitude": 25.063601,
            "longitude": 56.317859
          },
          {
            "latitude": 25.114254,
            "longitude": 56.304287
          },
          {
            "latitude": 25.13229,
            "longitude": 56.280571
          },
          {
            "latitude": 25.125012,
            "longitude": 56.253409
          },
          {
            "latitude": 25.087243,
            "longitude": 56.232844
          }
        ],
        "freezone": false,
        "id": 35,
        "name": "Al Hail Industrial",
        "region_id": 7,
        "website": null
      },
      {
        "coordinates": [
          {
            "latitude": 25.539877,
            "longitude": 56.246324
          },
          {
            "latitude": 25.573114,
            "longitude": 56.299513
          },
          {
            "latitude": 25.584918,
            "longitude": 56.302703
          },
          {
            "latitude": 25.599228,
            "longitude": 56.341305
          },
          {
            "latitude": 25.629656,
            "longitude": 56.322292
          },
          {
            "latitude": 25.629083,
            "longitude": 56.290954
          },
          {
            "latitude": 25.607123,
            "longitude": 56.255811
          },
          {
            "latitude": 25.565896,
            "longitude": 56.230066
          }
        ],
        "freezone": false,
        "id": 36,
        "name": "Dibba Industrial",
        "region_id": 7,
        "website": null
      }
    ],
    "name": "Fujairah"
  }
]
